import React from "react";
import classNames from "classnames";
import { SPIN_TYPES, SpinProps } from "./PropsType";
import { getOtherProperties } from "../common/Utils";

export default function Spin(props: SpinProps) {
  const {
    className,
    height = 100,
    type = "circleRound",
    size = "xs",
    prefixCls = "bm-Spin",
    width = 100,
    color = "#303548",
    ...other
  } = props;
  const styleClass = classNames(prefixCls, className);
  const otherProps = getOtherProperties(other, ["height", "size", "width"]);
  const getSpinElement = (type: SPIN_TYPES, spanSize: number) => {
    const spans: any[] = [];
    let num = 8;
    let height;
    if (type !== "snake") {
      switch (type) {
        case "lineSquare":
        case "lineRound":
        case "lineBounce":
          num = 5;
          break;
      }
      if (type === "lineSquare" || type === "lineRound") {
        height = spanSize * 0.1;
      }
      for (let i = 0; i < num; i++) {
        spans.push(<span key={i} style={{ height, background: color }} />);
      }
    } else {
      spans.push(<div className={`${prefixCls}-snake`} key="snake" />);
    }

    return <div className={classNames("loader", type)}>{spans}</div>;
  };

  const getSize = () => {
    let width: any = props.width || 100;
    let height: any = props.height || 100;
    switch (size) {
      case "xs":
        width *= 0.25;
        height *= 0.25;
        break;
      case "sm":
        width *= 0.5;
        height *= 0.5;
        break;
    }
    switch (type) {
      case "lineSquare":
      case "lineRound":
      case "lineBounce":
        height = width * 0.5;
        break;
    }
    return { width, height };
  };
  const styles = { ...getSize() };

  return (
    <div className={styleClass} {...otherProps} style={styles}>
      {getSpinElement(type!, styles.width)}
    </div>
  );
}
